export const VISIT_TYPES: string[] = ['individual', 'group'];
